import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { bookingStatusLabelKey, bookingStatusTone } from '../../lib/bookingLifecycle';
import s from './BookingDetail.module.css';

interface BookingStatusPillProps {
    status: number | string;
    cancellationSource?: string | null;
    className?: string;
}

/**
 * O1 (AB#2199) — the owner-facing status label + colour, identical on the Calendar
 * booking detail and the Appointments list ("Awaiting confirmation", "Confirmed",
 * "Declined by salon", …). Colours follow the founder status rule via tokens.
 */
const BookingStatusPill: React.FC<BookingStatusPillProps> = ({ status, cancellationSource, className }) => {
    const { t } = useLanguage();
    const tone = bookingStatusTone(status);
    return (
        <span
            className={`${s.statusPill} ${s[`tone-${tone}`] ?? ''} ${className ?? ''}`}
            data-testid="booking-status-pill"
            data-tone={tone}
        >
            {t(bookingStatusLabelKey(status, cancellationSource))}
        </span>
    );
};

export default BookingStatusPill;
